import { createFileRoute } from "@tanstack/react-router";
import { supporters } from "@/data/supporters";
import { ProfilePage, profileHead, ProfileError } from "@/pages/ProfilePage";

const supporter = supporters.find((s) => s.id === "christian")!;

export const Route = createFileRoute("/de/mutiger-christ")({
  head: () => profileHead(supporter, "de"),
  errorComponent: ({ error }) => <ProfileError locale="de" error={error} />,
  component: () => <ProfilePage supporter={supporter} locale="de" />,
});
